<template>
  <b-container>
    <template v-if="!accountRoleTemplateId">
      <indica-form
        table-name="AccountRoleTemplate"
        @refresh="accountRoleTemplateCreated"
      />
      <indica-list
        table-name="AccountRoleTemplate"
        :override-fields="['name', 'roleTypeId', 'description']"
        @onRowClick="setAccountRoleTemplateId"
      />
    </template>
    <b-container v-if="accountRoleTemplateId" class="self-assesment">
      <b-row>
        <b-col>
          <indica-form
            table-name="AccountRoleTemplate"
            :id-to-edit="accountRoleTemplateId"
            :edit-mode="false"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Ruled By">
            <b-form-radio-group
              id="radio-group-1"
              v-model="ruledBySelected"
              :options="options"
              name="radio-options"
              :selectable="(car) => car.disabled"
            />
            <b-row v-if="arrayWithTitles" style="margin-top: 20px">
              <b-button
                v-if="!editMode"
                variant="primary"
                style="
                  margin-top: 15px;
                  position: absolute;
                  z-index: 999999999999;
                  right: 27px;
                "
                @click="editMode = !editMode"
              >
                Editar
              </b-button>
              <b-button
                class="btn"
                style="
                  margin-top: 71px;
                  position: absolute;
                  z-index: 999999999999;
                  right: 27px;
                  background-color: #1e4380;
                  color: white;
                "
              >
                Actualizar Roles
              </b-button>
              <b-button
                v-if="editMode && !saveOnClick"
                variant="primary"
                style="
                  margin-top: 15px;
                  position: absolute;
                  z-index: 999999999999;
                  right: 27px;
                "
                @click="save()"
              >
                Guardar
              </b-button>
              <b-col>
                <!--                <div :key="index" v-for="(data,index) in arrayWithTitles"  >
                  <b-checkbox v-model="data.selected">{{data.name}}</b-checkbox>
                  <div v-if="data.selected && data.list && data.list.length" style="padding-left: 15px">
                    <b-checkbox :key="index2" v-for="(data2,index2) in data.list" @change="changeChild(data2)"  v-model="data2.selected">{{data2.name}}</b-checkbox>
                  </div>
                </div>-->
                <div v-for="(data, index) in arrayWithTitles" :key="index">
                  <div v-if="data.list && data.list.length">
                    <div
                      style="display: inline-block"
                      :class="{
                        'caret-down': data.open,
                        'caret-right': !data.open,
                      }"
                      @click="open(data)"
                    />
                    <div style="display: inline-block">
                      {{ data.name }}
                    </div>
                    <div
                      style="
                        display: inline-block;
                        cursor: pointer;
                        color: gray;
                        font-size: 11px;
                      "
                      @click="selectAllChildren(data)"
                    >
                      Select All
                    </div>
                  </div>
                  <div v-if="!data.list || !data.list.length">
                    <b-checkbox
                      v-model="data.selected"
                      :disabled="!editMode"
                      @change="change(data)"
                    >
                      {{ data.name }}
                    </b-checkbox>
                  </div>
                  <div
                    v-if="data.open && data.list && data.list.length"
                    style="padding-left: 15px"
                  >
                    <b-checkbox
                      v-for="(data2, index) in data.list"
                      :key="index"
                      v-model="data2.selected"
                      :disabled="!editMode"
                      @change="changeChild(data2)"
                    >
                      {{ data2.name }}
                    </b-checkbox>
                  </div>
                </div>
              </b-col>
              <!--        <b-col cols="6">
                        <div style="height: 500px;overflow: scroll;">
                          <draggable class="list-group" :list="grantPermissionsArray" group="people" @change="log">
                            <div
                              class="list-group-item"
                              v-for="(element, index) in grantPermissionsArray"
                              :key="element.name"
                            >
                              {{ element.name }}
                            </div>
                          </draggable>
                        </div>
                      </b-col>
                      <b-col cols="6">
                        <div style="    height: 500px;    overflow: scroll;">
                          <draggable class="list-group" :list="revokePermissionsArray" group="people">
                            <div
                              class="list-group-item"
                              v-for="(element, index) in revokePermissionsArray"
                              :key="element.name"
                            >
                              {{ element.name }}
                            </div>
                          </draggable>
                        </div>
                      </b-col>-->
            </b-row>
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>
    <b-modal
      id="modalInfo"
      v-model="showModal"
      modal-class="modalInfo"
      :title="$t('Guardado satisfactoriamente')"
    >
      <p>{{ $t("Guardado satisfactoriamente") }}</p>
      <div slot="modal-footer" class="w-100">
        <b-btn variant="primary" @click="showModal = false">
          {{ $t("label_selfAssessment_submitReview_modal_confirmation") }}
        </b-btn>
      </div>
    </b-modal>
  </b-container>
</template>
<script>
import { axiosCall } from "../../../utils/axiosCall";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import IndicaList from "../../../utils/forms/indica-list";
import IndicaForm from "../../../utils/forms/indica-form";
import { GetTableDataByName } from "../../../utils/forms/tablesConfiguration";

export default {
  name: "ConfigurationAccessControlTemplate",
  components: { IndicaList, IndicaForm },
  data() {
    return {
      editMode: false,
      saveOnClick: false,
      showModal: false,
      accountRoleTemplateId: null,
      roleTypes: [],
      readyPermissions: false,
      ruledBySelected: null,
      availablePermissions: [],
      grantPermissionsArray: [],
      revokePermissionsArray: [],
      arrayWithTitles: [],
      accountRoleTemplate: null,
      options: [
        { text: "Tag", value: "ruleByTag" },
        { text: "Region", value: "ruleByRegion" },
        { text: "Country", value: "ruleByCountry" },
        { text: "Language", value: "ruleByLanguage", disabled: true },
      ],
    };
  },
  computed: {},
  watch: {
    ruledBySelected: async function () {
      await this.getAccessControlTemplates();
    },
  },
  created: async function () {
    await this.getRoleTypes();
  },
  methods: {
    change: async function (data) {
      if (!data.list) {
        await this.changeChild(data);
      }
    },
    open: function (data) {
      data.open = !data.open;
      this.$forceUpdate();
    },
    selectAllChildren: function (data) {
      data.list.map((child) => {
        this.changeChild(child, true);
        child.selected = true;
      });
      this.$forceUpdate();
    },
    accountRoleTemplateCreated(data) {
      this.setAccountRoleTemplateId(data.id);
    },
    setAccountRoleTemplateId: async function (accountRoleTemplateRow) {
      const tableData = GetTableDataByName("AccountRoleTemplate");
      this.accountRoleTemplateId = accountRoleTemplateRow[tableData.idName];
      await axiosCall({
        url: `AccountRoleTemplates/${this.accountRoleTemplateId}`,
        method: "get",
      }).then((response) => {
        this.accountRoleTemplate = response.data;
      });
      await this.getAvailablePermissions();
      if (this.ruledBySelected) {
        await this.getAccessControlTemplates();
      }
      // this.$refs.wizard.nextTab()
    },
    changeChild: async function (data, valueToForce) {
      if (this.saveOnClick) {
        await this.addMany(data, valueToForce || !data.selected);
        await this.getAvailablePermissions();
        await this.getAccessControlTemplates();
      } else {
        if (data.list) {
          data.list.map((data2) => {
            data2.selected = true;
          });
        }
      }
    },
    async save() {
      await this.arrayWithTitles.map(async (data) => {
        if (data.list) {
          await data.list.map(async (data2) => {
            await this.addMany(data2, data2.selected);
          });
        } else {
          await this.addMany(data, data.selected);
        }
      });
      this.editMode = false;
      this.showModal = true;
    },
    addMany: async function (many, checked) {
      const data = {
        accountRoleTemplateId: this.accountRoleTemplateId,
        permissionId: many.customId,
      };
      data[this.ruledBySelected] = true;
      if (checked === false) {
        if (many && many.relationshipId) {
          await axiosCall({
            url: `accessControlTemplates/removePermission`,
            method: "post",
            data,
          });
        }
      } else {
        if (!many || !many.relationshipId) {
          await axiosCall({
            url: `accessControlTemplates`,
            method: "put",
            data,
          });
        }
      }
    },
    getAvailablePermissions: async function () {
      this.readyPermissions = false;
      await axiosCall({ url: `Permissions`, method: "get" }).then(
        async (response) => {
          this.availablePermissions = response.data;
          const where = {};
          where["where"] = {};
          where["where"]["roleTypeId"] = this.accountRoleTemplate.roleTypeId;
          await axiosCall({
            url: `PermissionRoleTypes?filter=` + JSON.stringify(where),
            method: "get",
          }).then((responseG) => {
            const granted = responseG.data.map(
              (permission) => permission.permissionId
            );
            /* const arrayWithTitles = {}
            response.data.map(data => {
              data.selected = granted.includes(data[this.currentMany.id])
              const split = data.name.split('.')
              if (typeof arrayWithTitles[split[0]] === 'undefined') {
                arrayWithTitles[split[0]] = {
                  name: split[0],
                  list: []
                }
              }
              if (data.selected) {
                arrayWithTitles[split[0]].selected = true
              }
              const dat = { ...data }
              dat.name = dat.name.replace(split[0], '').replace('.', '')
              arrayWithTitles[split[0]].list.push(dat)
            })
            this.arrayWithTitles = Object.values(arrayWithTitles)*/
            this.availablePermissions = response.data.filter((permission) =>
              granted.includes(permission.customId)
            );
          });
          // this.readyPermissions = true
        }
      );
    },
    getAccessControlTemplates: async function () {
      const where = {};
      where["where"] = {};
      where["where"]["accountRoleTemplateId"] = this.accountRoleTemplateId;
      where["where"][this.ruledBySelected] = true;
      await axiosCall({
        url: `accessControlTemplates?filter=` + JSON.stringify(where),
        method: "get",
      }).then((responseG) => {
        const granted = responseG.data.map((dat) => dat.permissionId);
        const arrayWithTitles = {};
        this.availablePermissions.map((data) => {
          data.selected = granted.includes(data.customId);
          const permissiong = responseG.data.find(
            (grant) => grant.permissionId === data.customId
          );
          if (permissiong) {
            data.relationshipId = permissiong.id;
          }
          const split = data.name.split(".");
          if (typeof arrayWithTitles[split[0]] === "undefined") {
            arrayWithTitles[split[0]] = {
              name: split[0],
              list: [],
            };
          }
          if (data.selected) {
            arrayWithTitles[split[0]].selected = true;
          }
          const dat = { ...data };
          dat.name = dat.name.replace(split[0], "").replace(".", "");
          arrayWithTitles[split[0]].list.push(dat);
        });
        this.arrayWithTitles = Object.values(arrayWithTitles);
        /* this.grantPermissionsArray = this.availablePermissions.filter(permission => grantedPermissions.includes(permission.customId))
          this.revokePermissionsArray = this.availablePermissions.filter(permission => !grantedPermissions.includes(permission.customId))*/
        this.readyPermissions = true;
      });
    },

    getRoleTypes: async function () {
      await axiosCall({
        url: `RoleTypes`,
        method: "get",
      }).then((response) => {
        this.roleTypes = response.data.map((roleT) => {
          return { text: roleT.name, value: roleT.id };
        });
      });
    },
  },
};
</script>

<style lang="scss">
#radio-group-1 .custom-radio {
  margin-right: 30px;
  margin-left: 30px;
}
</style>
